import React from "react";
import { createRoot } from "react-dom/client";
// antd 5 still calls the React 18 render APIs for its imperative pop-ups; this patch maps them to React 19.
import "@ant-design/v5-patch-for-react-19";

import reportWebVitals from "./reportWebVitals";
import App from "./App";

createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
